/* eslint semi:0 */
import { isDesktop, } from 'utils/ua'
import BaseClass from 'application/BaseClass'
import {
  make as makeMithrilComponent,
  empty as emptyMithrilComponent,
} from 'utils/component'
import AdminDropdownView from 'views/AdminDropdownView'
import AdminDropdownVm from 'vms/adminDropdownVm'
import userStore from 'stores/userStore'


class AdminDropdownController extends BaseClass {

  constructor(options = {}) {
    super(options)
    const store = options.store || userStore
    const { blockName, } = options.rootNode.dataset
    this.vm = AdminDropdownVm.create({ store, blockName, })
  }

}

const component = isDesktop ? makeMithrilComponent(AdminDropdownController, AdminDropdownView) : emptyMithrilComponent
export default component



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/adminDropdownComponent.js